/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ReceiveFirmware$Params {
  vendor: string;
  imei?: string;
  serialNumber?: string;
}

export function receiveFirmware(http: HttpClient, rootUrl: string, params: ReceiveFirmware$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, receiveFirmware.PATH, 'get');
  if (params) {
    rb.path('vendor', params.vendor, {});
    rb.query('imei', params.imei, {});
    rb.query('serialNumber', params.serialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

receiveFirmware.PATH = '/api/{vendor}/router/firmware';
